<template>
    <div>
        <div>
            <el-tooltip effect="dark" content="取消分拨" placement="bottom">
                <!-- v-has="'04010006'" -->
                <span class="mgl-2 bigData-btn-cancel-allocation">
                    <el-button
                        icon="el-icon-c-scale-to-original"
                        size="mini"
                        @click="handleCancleAllocate"
                    ></el-button>
                </span>
            </el-tooltip>
            <el-tooltip effect="dark" content="批量分拨" placement="bottom">
                <span v-has="''" class="mal-2 bigData-btn-batch-allocation">
                    <el-button icon="el-icon-share" size="mini" @click="handleBatchAllocate"></el-button>
                </span>
            </el-tooltip>
        </div>
        <RevocationDialog
            ref="revocationDialog"
            v-if="revocationShow"
            :revocationShow.sync="revocationShow"
            @confirm="revocationConfirm"
        ></RevocationDialog>
        <!-- 下发弹窗 -->
        <issue-dialog
            ref="issueDialog"
            v-if="issueDialogVisible"
            :dialogVisible.sync="issueDialogVisible"
            :taskDataList="checkedSourceList"
            @confirm="advanceDialogConfirm"
            @handleClose="handleIssueDialogClose"
        ></issue-dialog>
        <!-- 分拨弹窗 -->
        <distribution
            v-if="tableVisible"
            :tableVisible.sync="tableVisible"
            :checkedSourceList="checkedSourceList"
            type="2"
            ref="distributionRef"
            @distributionOk="distributionOk"
        ></distribution>
        <!-- 分拨弹窗 -->
    </div>
</template>
<script>
import RevocationDialog from '../dialog/Revocation';
import {
    issueCarrier,
    getCancleAllocate,
    confirmIssueCarrier
} from '../../../../api/basePlatoon';
import { verifyLBXOrder, getMesTip } from '../../../../utils/dispatchCenter.js';
import IssueDialog from '../../../../components/dialog/IssueDialog';
import Distribution from '../dialog/Distribution.vue';

export default {
    props: {
        checkedSourceList: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    components: { RevocationDialog, IssueDialog, Distribution },
    data () {
        return {
            revocationShow: false,
            issueDialogVisible: false,
            tableVisible: false // 批量分拨弹窗开关
        };
    },
    methods: {
        revocation () {
            if (this.checkedSourceList.length === 0) {
                this.$message.warning('请勾选运输单');
                return false;
            }
            const reject = this.checkedSourceList.find(item => item.carrierVisibleFlag === 'N');
            if (reject) {
                this.$message.warning({
                    message: `运输单号：${reject.taskNo} 未下发，无法撤回`,
                    duration: 5000
                });
                return false;
            }
            const reject2 = this.checkedSourceList.find(item => item.taskStatus !== 0);
            if (reject2) {
                this.$message.warning({
                    message: `运输单号：${reject2.taskNo} 非待调度运单，无法撤回`,
                    duration: 5000
                });
                return false;
            }
            const verifyLBXOrderRes = verifyLBXOrder(this.checkedSourceList);
            if (getMesTip(verifyLBXOrderRes, this)) { return; }
            this.revocationShow = true;
        },
        // 下发 1
        issued () {
            if (this.checkedSourceList.length === 0) {
                this.$message.warning('请勾选运输单');
                return false;
            }
            const reject = this.checkedSourceList.find(item => item.carrierVisibleFlag === 'Y');
            if (reject) {
                this.$message.warning({
                    message: `运输单号：${reject.taskNo} 已下发，不能重复下发`,
                    duration: 5000
                });
                return false;
            }
            const reject2 = this.checkedSourceList.find(item => item.taskStatus !== 0);
            if (reject2) {
                this.$message.warning({
                    message: `运输单号：${reject2.taskNo} 非待调度运单，无法下发`,
                    duration: 5000
                });
                return false;
            }
            const verifyLBXOrderRes = verifyLBXOrder(this.checkedSourceList);
            if (getMesTip(verifyLBXOrderRes, this)) { return; }
            setTimeout(() => {
                this.checkedSourceList.forEach((item, index, arr) => {
                    if (item.consolidationOrderNo && item.consolidationNum) {
                        const totalCount = arr.filter(item2 => item2.consolidationOrderNo === item.consolidationOrderNo).length;
                        if (totalCount < item.consolidationNum) {
                            this.$message.warning({
                                message: `集拼单号：${item.consolidationOrderNo}未齐套,集拼单量应为：${item.consolidationNum}个,目前只勾选${totalCount}个，如有疑问请咨询基地！`,
                                duration: 5000
                            });
                        }
                    }
                });
            }, 50);
            this.issueDialogVisible = true;
        },
        // 撤回 2
        revocationConfirm (data) {
            this.$confirm('你确定要撤回吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$refs.revocationDialog.loading();
                const params = {
                    carrierVisibleFlag: 'N',
                    taskNos: [],
                    ...data
                };
                this.checkedSourceList.forEach(item => params.taskNos.push(item.taskNo));
                issueCarrier(params).then(res => {
                    if (res) {
                        this.checkedSourceList.forEach(item => {
                            item.carrierVisibleFlagName = '否';
                            item.carrierVisibleFlag = 'N';
                            item.carrierName = '';
                            item.carrierCode = '';
                            item.procurementChannel = '';
                            item.procurementChannelName = '';
                        });
                        this.$message.success('撤回成功');
                        this.$emit('refreshList');
                    }
                }).finally(() => {
                    this.revocationShow = false;
                });
            }).catch(() => { });
        },
        // 承运商弹框返回值  做下发操作  下发 3
        advanceDialogConfirm (data) {
            const params = {
                carrierVisibleFlag: 'Y',
                taskNos: [],
                ...data
            };
            this.checkedSourceList.forEach(item => params.taskNos.push(item.taskNo));
            issueCarrier(params).then(res => {
                if (res) {
                    const successHandle = () => {
                        this.checkedSourceList.forEach(item => {
                            item.carrierVisibleFlagName = '是';
                            item.carrierVisibleFlag = 'Y';
                            item.carrierName = data.carrierName;
                            item.carrierCode = data.carrierCode;
                            item.procurementChannel = data.procurementChannel;
                            item.procurementChannelName = data.procurementChannelName;
                        });
                        this.$message.success('下发成功');
                        this.issueDialogVisible = false;
                        this.$emit('refreshList');
                    };
                    if (res.data.flag !== 0) {
                        const tipArr = res.data.msg.split(',');
                        this.$confirm(tipArr.join('<br />') + '<br />' + '你确定要下发吗?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            dangerouslyUseHTMLString: true,
                            type: 'warning'
                        }).then(() => {
                            confirmIssueCarrier(params).then(res => {
                                if (res) {
                                    successHandle();
                                }
                            }).catch(() => {
                            });
                        }).catch(() => {
                            this.$refs.issueDialog.loading = false;
                        });
                        return false;
                    }
                    successHandle();
                }
            }).catch(() => {
            });
        },
        handleIssueDialogClose () {
            this.issueDialogVisible = false;
        },
        handleCancleAllocate () {
            if (this.checkedSourceList.length < 1) return this.$message.warning('请选择待调度的运输单进行操作');
            let cancleAllocateCount = 0;
            this.checkedSourceList.forEach(item => {
                if ((item.orderType === 'RI' && ['IN', 'DI', 'RDI'].includes(item.taskType)) || item.distributionFlag === 'N') ++cancleAllocateCount;
            });
            if (cancleAllocateCount) return this.$message.warning('存在不能取消分拨的单！');
            const verifyLBXOrderRes = verifyLBXOrder(this.checkedSourceList);
            if (getMesTip(verifyLBXOrderRes, this)) { return; }
            this.$confirm('是否确认取消分拨？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const taskNos = this.checkedSourceList.map(el => el.taskNo);
                getCancleAllocate({ taskNos: taskNos }).then(res => {
                    if (res) {
                        this.$message({
                            showClose: true,
                            message: res.msg || '已取消分拨',
                            type: 'success',
                            duration: 5000
                        });
                        this.$emit('refreshList');
                    };
                });
            }).catch(() => { });
        },
        // 批量分拨
        handleBatchAllocate () {
            if (!this.checkedSourceList.length) return this.$message.warning('请选择待调度的运输单进行操作');
            this.tableVisible = true;
        },
        distributionOk () {
            this.tableVisible = false;
            this.$emit('refreshList');
        }
    }
};
</script>
